var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2498_98842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V14C24 15.1046 23.1046 16 22 16H2C0.89543 16 0 15.1046 0 14V2Z",
    fill: "#FDEACE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5044 3.26367L9.33984 3.28143L9.49634 12.7363L14.6609 12.7186L14.5044 3.26367Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6798 8.02796C9.64784 6.10491 10.5093 4.3962 11.8586 3.28785C10.8401 2.48862 9.56328 2.00802 8.17913 2.01276C4.90002 2.02399 2.29181 4.72536 2.34711 8.05308C2.40241 11.3808 5.1001 14.064 8.37922 14.0528C9.76336 14.048 11.0241 13.5587 12.0159 12.7526C10.6302 11.6704 9.71176 9.95102 9.6798 8.02796Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6536 7.94699C21.7089 11.2747 19.1007 13.9761 15.8216 13.9873C14.4374 13.992 13.1606 13.5114 12.1421 12.7122C13.5079 11.6038 14.3529 9.89516 14.3209 7.9721C14.2889 6.04905 13.3708 4.34643 11.9848 3.24745C12.9766 2.44134 14.2373 1.95205 15.6215 1.94731C18.9006 1.93608 21.5986 4.63599 21.6536 7.94699Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2498_98842"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.1f4351ce3b010b3a3252b8895f897ad6.svg";
export { ForwardRef as ReactComponent };